/**
 * @Author : DingHuiHui
 * @Content : 机器人与设计器接口配置
 */
import $http from '@/utils/requestAxios'

export const apiRobot = {
  // 设计器
  design () {
    return $http.get('/studio')
  },
  // 修改设计器
  editDesign (id, stuAlias) {
    return $http.put('/studio', { id, stuAlias })
  },
  // 免费延长30天
  feeExtend () {
    return $http.put('/studio/ontrial')
  },
  // 机器人列表
  list (params, page = 1, size = 10000) {
    return $http.get('/agents', { ...params, page, size })
  },
  // 统计
  count () {
    return $http.get('/agents/status')
  },
  // 删除机器人
  delete (id) {
    return $http.delete('/agents', { id })
  },
  // 修改机器人
  edit (id, agentAlias) {
    return $http.put('/agents', { id, agentAlias })
  },
  // 申请续期
  apply (params) {
    return $http.put('/studio/postpone', params)
  }
}
